const AGREEMENT_RETURN_PATH = '/organisation/agreement';

// Build the post-migration dashboard URL without allowing provider IDs to alter the route shape.
export function existingProviderAgreementUrl(providerId: string): string {
    const normalizedProviderId = providerId.trim();
    return `${AGREEMENT_RETURN_PATH}?providerId=${encodeURIComponent(normalizedProviderId)}`;
}

// Only the dedicated Agreement deep link may request an initial platform-provider selection.
export function agreementProviderIdFromLocation(
    location: Pick<Location, 'pathname' | 'search'> = window.location
): string {
    if (location.pathname !== AGREEMENT_RETURN_PATH) return '';
    const providerId = new URLSearchParams(location.search).get('providerId')?.trim() || '';
    return providerId && providerId.length <= 200 && !providerId.includes('/') ? providerId : '';
}

export function isOrganisationRoute(pathname: string): boolean {
    return pathname === '/organisation/billing' || pathname === AGREEMENT_RETURN_PATH;
}

export function isAgreementRoute(pathname: string): boolean {
    return pathname === AGREEMENT_RETURN_PATH;
}
